import React from 'react';
import MobileStoreRankDetails from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/StoreRank';
import PCStoreRankDetails from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/StoreRank';
import ConsoleStoreRankDetails from '@/pages/intelligence/pages/TopCharts/ConsoleGames/components/GamesDetails/StoreRank';
import PCConsoleStoreRankDetails from '@/pages/intelligence/pages/TopCharts/PCConsoleGames/components/GamesDetails/StoreRank';
import useRadioOptionsTipsGetterOfRegionSelect from '@intelligence/hooks/useRadioOptionsTipsGetterOfRegionSelect';

import type { IBaseProps } from '@/pages/intelligence/types/common';

export interface IStoreRankDetailsProps extends IBaseProps {
  entityType: 'mobile' | 'pc' | 'console' | (string & {});
  isBasicLoading: boolean;
  gameId: string;
  appIds?: any;
  tabSegment?: any;
  moduleName?: any;
  appIdListAll?: any[];
  basicInfo: object | any;
  countryList: any[];
  gameName?: string;
  selectPlatform?: any[];
}

const StoreRankDetails: React.FC<IStoreRankDetailsProps> = (props) => {
  const { entityType } = props;

  const getRadioOptionsTips = useRadioOptionsTipsGetterOfRegionSelect();

  if (entityType === 'mobile') {
    return <MobileStoreRankDetails {...props} />;
  }
  if (entityType === 'pc') {
    return <PCStoreRankDetails {...props} getRadioOptionsTips={getRadioOptionsTips} />;
  }
  if (entityType === 'console') {
    return <ConsoleStoreRankDetails {...props} />;
  }
  if (entityType === 'combine') {
    return <PCConsoleStoreRankDetails {...props} getRadioOptionsTips={getRadioOptionsTips} />;
  }
  return null;
};

export default StoreRankDetails;
